import { render } from "./StatsWidgetTabsConfig.vue?vue&type=template&id=e4320e74"
import script from "./StatsWidgetTabsConfig.vue?vue&type=script&lang=ts"
export * from "./StatsWidgetTabsConfig.vue?vue&type=script&lang=ts"
script.render = render

export default script